import React, { useState, useMemo } from "react";
import { Modal, Fade } from "@mui/material";
import { connect } from "react-redux";
import View from "@modul-connect/shared/components/atoms/view";
import { H1, H3, P } from "@modul-connect/shared/components/atoms/text";
import Button from "@modul-connect/shared/components/atoms/button";
import modal from "@modul-connect/shared/components/atoms/modal";
import TextField from "@modul-connect/shared/components/molecules/textField";
import { setWeightCalibration } from "../../../../../state/actions/vehicles";

const ModalEditWeightCalibration = ({
  openModal,
  onClose,
  vehicle,
  setWeightCalibration,
}) => {
  const [front, setFront] = useState("");
  const [rear, setRear] = useState("");

  React.useEffect(() => {
    if (openModal) {
      setFront("");
      setRear("");
    }
  }, [openModal]);

  const gross = useMemo(() => {
    const f = Number(front);
    const r = Number(rear);
    if (!front && !rear) return "";
    return String((isNaN(f) ? 0 : f) + (isNaN(r) ? 0 : r));
  }, [front, rear]);

  const net = gross ? -gross : ""; 

  const canSubmit = front !== "" && rear !== "" && !isNaN(Number(front)) && !isNaN(Number(rear));

  const handleSubmit = () => {
    const telematicsId = vehicle?.telematicsData?.telematicsId
    setWeightCalibration(telematicsId, {
      front: Number(front),
      rear: Number(rear),
      gross: Number(gross),
      net: Number(net),
    });

    onClose();
  };

  return (
    <Modal open={openModal} onClose={onClose}>
        <View extend={modal.container_medium}>
          <View extend={modal.header}>
            <H1 text="Weight Calibration" />
          </View>

          <View extend={modal.content}>
            <H3 noPadding>Axle Weights</H3>
            <P extend={{ marginTop: 12, marginBottom: 20 }}>
              Enter front and rear axle weights (kg).
            </P>

            <View
              extend={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                marginBottom: 24,
              }}
            >
              <TextField
                name="Front"
                type="number"
                placeholder="Front axle"
                value={front}
                onChange={(e) => setFront(e.target.value)}
                extend={{ flex: 1 }}
              />

              <TextField
                name="Rear"
                type="number"
                placeholder="Rear axle"
                value={rear}
                onChange={(e) => setRear(e.target.value)}
                extend={{ flex: 1 }}
              />
            </View>

            <View
              extend={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
              }}
            >
              <TextField
                name="Gross"
                type="number"
                label="Gross"
                placeholder="Gross"
                value={gross}
                disabled
                extend={{ flex: 1 }}
              />

              <TextField
                name="Net"
                type="number"
                label="Net"
                placeholder="Net"
                value={net}
                disabled
                extend={{ flex: 1 }}
              />
            </View>
          </View>

          <View extend={modal.footer}>
            <Button noBg cancel onClick={onClose}>
              Cancel
            </Button>

            <Button noBg disabled={!canSubmit} onClick={handleSubmit}>
              Save
            </Button>
          </View>
        </View>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setWeightCalibration: (telematicsId, calibration) =>
    dispatch(setWeightCalibration(telematicsId, calibration)),
});

export default connect(null, mapDispatchToProps)(ModalEditWeightCalibration);